@for (toast of toasts; track toast.id) {
  <div class="toast" [ngClass]="getToastClasses(toast)" #toasts id="{{toast.id}}">
    <div class="toast-message-list">
      <div class="toast-message">
        <!-- both corner marks float, so they take width on the FIRST line only and the message
             wraps back to full width beneath them. they must come before the text. -->
        @if (getToastIcon(toast)) {
          <span class="toast-icon"><cs-icon [name]="getToastIcon(toast)"></cs-icon></span>
        }
        @if (getCloseForm(toast) === ToastCloseForm.CornerX) {
          <a class="toast-close-x" tappable (click)="onClickClose(toast)"><cs-icon name="close"></cs-icon></a>
        }
        {{ toast.opts.message }}@if (toast.opts.messageLink) {
          <a class="message-link" tappable (click)="onClickMessageLink(toast)">{{ toast.opts.messageLink }}</a>
        }
      </div>
      @if (toast.opts.message2) {
        <div class="toast-message">{{ toast.opts.message2 }}</div>
      }
    </div>
    @if (hasActionRow(toast)) {
      <!-- one row, right-aligned, the emphasised button last. the close lives here as a WORD
           rather than as a mark above the action — see ToastCloseForm. -->
      <div class="toast-actions">
        @if (toast.opts.showDontShowAgainButton) {
          <a class="toast-button toast-button-secondary" tappable (click)="onClickDontShowAgain(toast)">{{ LL.common.toast.dontShowAgain() }}</a>
        }
        @if (getCloseForm(toast) === ToastCloseForm.WordedButton) {
          <a class="toast-button" [ngClass]="isCloseThePrimaryButton(toast) ? 'toast-button-primary' : 'toast-button-secondary'" tappable (click)="onClickClose(toast)">{{ toast.opts.closeButtonText || LL.common.buttons.dismiss() }}</a>
        }
        @if (toast.opts.actionButtonText) {
          <a class="toast-button toast-button-primary" tappable (click)="onClickAction(toast)">{{ toast.opts.actionButtonText }}</a>
        }
      </div>
    }
  </div>
}
